import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

interface CustomRedirectProps {
  to: string;
  search?: string;
}

export const CustomRedirect = (props: CustomRedirectProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (props.search) {
      navigate(props.to + props.search);
    } else {
      navigate(props.to);
    }
  }, []);

  return null;
};

export default CustomRedirect;
